import { render, staticRenderFns } from "./AddExamQuestionModal.vue?vue&type=template&id=b4c476e2&"
import script from "./AddExamQuestionModal.vue?vue&type=script&lang=js&"
export * from "./AddExamQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddExamQuestionModal.vue?vue&type=style&index=0&id=b4c476e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports